import { Input as InputPrimitive } from '@base-ui/react/input'

import { cn } from '@/utils/ui/styles'

import type { ComponentProps } from 'react'

function Input({
	className,
	type,
	...props
}: InputPrimitive.Props & ComponentProps<'input'>) {
	return (
		<InputPrimitive
			type={type}
			data-slot="input"
			className={cn(
				'dark:bg-input/30 border-input focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:aria-invalid:border-destructive/50 disabled:bg-input/50 dark:disabled:bg-input/80 file:text-foreground placeholder:text-muted-foreground h-9 w-full min-w-0 rounded-lg border bg-transparent px-2 py-1 text-base transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:ring-[3px] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:ring-[3px] md:text-sm',
				// Autofill
				'autofill:shadow-[inset_0_0_0px_1000px_var(--card)]/90 autofill:[-webkit-text-fill-color:var(--foreground)]',
				// 1Password Hack
				'data-[com-onepassword-filled=light]:shadow-[inset_0_0_0px_1000px_var(--card)]/90 data-[com-onepassword-filled=light]:[-webkit-text-fill-color:var(--foreground)]',
				className,
			)}
			{...props}
		/>
	)
}

export { Input }
